/** Доп. место под каждую строку переноса category label (fontSize 14) */
const CATEGORY_AXIS_EXTRA_LINE_HEIGHT = 10;

/**
 * Запас grid.bottom под многострочные category labels (перенос через \n).
 * Одна строка — 0, каждая следующая — +CATEGORY_AXIS_EXTRA_LINE_HEIGHT.
 */
export const getCategoryAxisLabelReserve = (labels: string[]): number => {
  const maxLines = labels.reduce<number>((max, label) => {
    const lineCount = String(label ?? '').split('\n').length;
    return Math.max(max, lineCount);
  }, 1);

  return Math.max(0, maxLines - 1) * CATEGORY_AXIS_EXTRA_LINE_HEIGHT;
};
